import { DateTransform } from '@app/shared/utils/date.transform';

export function getDateCounter(date): string {
  //TODO: fix test for this util
  if (!date) {
    return '';
  }

  if (new Date(date) < new Date()) {
    const duration = DateTransform.datesDuration(date, new Date());

    const counters = [];

    const years = duration.years;
    if (years > 0) {
      counters.push(`${years} year${years > 1 ? 's' : ''}`);
    }

    const months = duration.months;
    if (months > 0) {
      counters.push(`${months} month${months > 1 ? 's' : ''}`);
    }

    const days = duration.days;
    if (days > 0) {
      counters.push(`${days} day${days > 1 ? 's' : ''}`);
    }

    return counters.join(', ');
  }
}
